const BLACK_FRIDAY_PLAN_NAMES = new Set([
  'Pacote - Bronze com Dependente',
  'Pacote - Silver com Dependente',
]);

export function isBlackFridayPlan(planName?: string | null): boolean {
  if (!planName) {
    return false;
  }
  return BLACK_FRIDAY_PLAN_NAMES.has(planName);
}
